import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { GetNoteParams, GetNoteOptions } from '@nx-frontend/shared/types';
import { logger } from '@nx-frontend/shared/utils';

export async function getDump({ workspaceId, noteId }: GetNoteParams, options: GetNoteOptions): Promise<string | null> {
  let dump: string | null = null;

  try {
    const dumpServerUrl =
      -1 === generalEnv.dumpServerUrl.indexOf('://')
        ? `https://${generalEnv.nimbusDomain}${generalEnv.dumpServerUrl}`
        : generalEnv.dumpServerUrl;
    const response = await axiosClient.get<string>(`${dumpServerUrl}/${workspaceId}/${noteId}?format=base64`, {
      headers: {
        cookie: `eversessionid=${options.sessionId};`,
      },
    });
    dump = response.data;
  } catch (err) {
    logger.warn('Fail to get dump for note %s in workspace %s: %j', noteId, workspaceId, err);
  }

  return dump;
}
